import { environment } from 'src/environment';
export const API_CONFIG = {
  BASE_URL: environment.AYEN_API_URL,
} as const;
